export type SubjectArchivedAction = {
	type: 'SUBJECT_ARCHIVED';
	payload: { subjectId: number };
};

export default (subjectId: number): SubjectArchivedAction => ({
	type: 'SUBJECT_ARCHIVED',
	payload: { subjectId },
});
